/**
 * **How a `/zadania` card opens**: the kind's glyph in its own ink, the kind's name, one line of
 * context, and — where the body under it does not already carry it — the one big figure at the
 * right (KANON "Karty zadań", `catalogue6` `.k7-reason` / `.k7-big`).
 *
 * The figure is left off where the body draws it in its own place (`model/taskContent`'s
 * `figureStandsInBody`).
 */

import { useTranslation } from 'react-i18next';

import type { AttentionItem } from '../model/attentionItems';
import { figureStandsInBody, type TaskContent } from '../model/taskContent';
import { ReasonTile } from './ReasonTile';
import { HeroFigure } from './HeroFigure';
import styles from './taskHeading.module.css';

export function TaskHeading({ item, content }: { readonly item: AttentionItem; readonly content: TaskContent }) {
  const { t } = useTranslation();
  const hero = figureStandsInBody(item.reason) ? null : content.hero;

  return (
    <div className={styles.heading}>
      <ReasonTile item={item} size="xl" decorative />
      <div className={styles.text}>
        <h3 className={styles.title}>{t(item.titleKey)}</h3>
        {content.line === '' ? null : <p className={styles.line}>{content.line}</p>}
      </div>
      {hero === null ? null : (
        <p className={styles.figure}>
          <HeroFigure hero={hero} skin={styles} />
          <span className={styles.caption}>{hero.caption}</span>
        </p>
      )}
    </div>
  );
}
